/**
 * Returns the value of a provided cookie
 * @param {string} name Name of the cookie value to return
 * @returns {string} The value of the requested string
 */
export const getCookie = name => {
	const latestCookies = document.cookie.split('; ');
	return latestCookies.find(cookie => cookie.includes(name))?.slice(name.length + 1) || null;
};
